import styled from 'styled-components'
import { BLACK, GREEN_600, NEUTRAL_100 } from '../../styles/colors'
import { INTER } from '../../styles/fonts'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border: 2px solid ${NEUTRAL_100};
  border-radius: 8px;
  padding: 12px;
  width: 100%;
  cursor: ${props => props.onClick ? 'pointer' : 'default'};
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`

export const StepImage = styled.img`
  width: 36px;
  height: 36px;
  object-fit: cover;
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 80%;
  color: ${BLACK};
`

export const TitleText = styled.span`
  font-family: ${INTER.medium};
  font-size: 14px;
`

export const DescriptionText = styled.span`
  font-family: ${INTER.regular};
  font-size: 13px;
`

export const RightContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
`

export const CompletedIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  width: 18px;
  height: 18px;
  background-color: ${GREEN_600};
`

export const ChevronContainer = styled.div`
  margin-right: 4px;
`
